import { Glyph } from "../../../types";

const SvgSpain: Glyph = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
      <path fill="#d00" d="M0 0h512v140H0z" />
      <path fill="#ffce00" d="M0 140h512v232H0z" />
      <path fill="#d00" d="M0 372h512v140H0z" />
    </svg>
  );
};

export default SvgSpain;
